export enum AppMultipleSelectionBarButtonIcon {
  'delete' = 'trash-alt'
}
